import { useTranslation } from 'react-i18next';

function EmptyFieldLabel() {
  const { t } = useTranslation();

  return <p className="py-1 text-muted-foreground text-sm">{t(($) => $.none)}</p>;
}

export default EmptyFieldLabel;
